import React from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import InboxOutlinedIcon from '@material-ui/icons/InboxOutlined';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6, 3),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  icon: {
    width: 72,
    height: 72,
    borderRadius: 20,
    background:
      'linear-gradient(135deg, rgba(99,102,241,0.12), rgba(236,72,153,0.12))',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
  },
  description: {
    maxWidth: 380,
    marginBottom: theme.spacing(2),
  },
}));

const EmptyState = ({
  icon,
  title = 'Aucun élément',
  description = 'Il n\'y a rien à afficher pour le moment.',
  actionLabel,
  onAction,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.icon}>
        {icon || <InboxOutlinedIcon style={{ fontSize: 36 }} />}
      </Box>
      <Typography variant="h6" className={classes.title}>
        {title}
      </Typography>
      <Typography variant="body2" className={classes.description}>
        {description}
      </Typography>
      {actionLabel && onAction && (
        <Button variant="contained" color="primary" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState;
